// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"1b295a4e","787":"c1c2415d"}[chunkId] + ".chunk.js";
};